import { render, staticRenderFns } from "./dstr-invoice-verify.vue?vue&type=template&id=005fdf54&scoped=true"
import script from "./dstr-invoice-verify.vue?vue&type=script&lang=js"
export * from "./dstr-invoice-verify.vue?vue&type=script&lang=js"
import style0 from "./dstr-invoice-verify.vue?vue&type=style&index=0&id=005fdf54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fdf54",
  null
  
)

export default component.exports